import { Icon } from "@/components";
import { Divider } from "@/offering/divider";
import React from "react";
import { useState } from "react";
import { Dropdown, Button } from "react-bootstrap";
import { colors } from "../colors";

interface EventTypeValue {
  eventId?: string;
  otherDescription?: string;
}

interface SelectEventStepProps {
  onNext: (eventId: string, otherDescription?: string) => void;
  value?: EventTypeValue;
  options: { id: string; name: string }[];
}

export function SelectEventStep({
  onNext,
  options,
  value,
}: SelectEventStepProps) {
  const [selectedEventId, setSelectedEventId] = useState(value?.eventId);
  const [otherEventDescription, setOtherEventDescription] = useState(
    value?.otherDescription
  );

  const selectedEventName = options.find(
    (event) => event.id === selectedEventId
  )?.name;

  const handleSelect = (id: string | null) => {
    if (id) {
      setSelectedEventId(id);
      setOtherEventDescription(undefined);
    }
  };

  return (
    <div>
      <div className="border rounded">
        <Dropdown
          className="checkout-box-picker"
          onSelect={handleSelect}
          data-testid="event-space-select-event-dropdown"
        >
          <Dropdown.Toggle
            className="w-100"
            style={{
              backgroundColor: "white",
              borderColor: "#E0E0E0",
            }}
          >
            <div className="fw-normal d-flex justify-content-between align-items-center">
              {selectedEventName ? (
                <div>{selectedEventName}</div>
              ) : (
                <div style={{ color: colors.blackMinus40 }}>Select</div>
              )}
              <div>
                <Icon name="fi-chevron-down" size={24} />
              </div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu className="w-100">
            <div className="p-3 fw-bold" style={{ fontSize: 12 }}>
              SELECT EVENT
            </div>
            {options.map((option) => (
              <div key={option.id}>
                <Dropdown.Item eventKey={option.id} className="py-2">
                  {option.name}
                </Dropdown.Item>
                <Divider />
              </div>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      {selectedEventName === "Other" && (
        <div className="mt-3">
          <div style={{ fontSize: 14 }}>What type of event are you having?</div>
          <input
            type="text"
            className="mt-2 border rounded w-100 px-3 py-2"
            value={otherEventDescription}
            onChange={(e) => setOtherEventDescription(e.target.value)}
          />
        </div>
      )}
      <Button
        variant="outline-primary"
        className="mt-3 p-2"
        disabled={!selectedEventName}
        onClick={() =>
          selectedEventId && onNext(selectedEventId, otherEventDescription)
        }
        data-testid="event-space-select-event-next-step"
      >
        Next step
      </Button>
    </div>
  );
}
